module.exports = __webpack_public_path__ + "static/media/ADA-ETH.97761f45.svg";